'use memo';

import Icon from '@/components/Icon/Icon';
import { cn } from '@/lib/cn';
type AiChatFabProps = {
  onClick: () => void;
  ariaLabel: string;
};
export function AiChatFab({
  onClick,
  ariaLabel
}: AiChatFabProps) {
  return <button type="button" aria-label={ariaLabel} onClick={onClick} className={cn('fixed bottom-6 right-6 z-60 flex h-11 w-11 items-center justify-center rounded-full', 'bg-primary-fill text-primary-on-fill shadow-lg', 'hover:bg-primary-fill-hovered', 'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-border', 'transition-transform active:scale-95')}>
      <Icon iconName="BotMessageSquareIcon" size={20} inheritColor />
    </button>;
}